/**
 * F09 v2 — ID-document form state shared by the Approve dialog and the
 * Direct-verify page. The values object holds the raw ID number in memory only
 * (component state); nothing here persists or logs it.
 */
import { ID_DOCUMENT_TYPES, type IdDocumentType } from '@bravemove/types';

export interface IdDocumentValues {
  readonly number: string;
  readonly type: IdDocumentType | '';
  readonly country: string;
}

export interface IdDocumentErrors {
  readonly number?: string | undefined;
  readonly type?: string | undefined;
  readonly country?: string | undefined;
}

/** Empty form — issuing country defaults to Lebanon. */
export const EMPTY_ID_DOCUMENT: IdDocumentValues = { number: '', type: '', country: 'LB' };

/** ISO 3166-1 alpha-2, uppercase (mirrors the frozen Zod schema). */
export const COUNTRY_RE = /^[A-Z]{2}$/;

export function isIdDocumentType(v: string): v is IdDocumentType {
  return (ID_DOCUMENT_TYPES as readonly string[]).includes(v);
}
